export default __webpack_public_path__ + "static/img-1-baf5ef92c1a4ba7b59cf649269f5e080.png";